module.exports = __webpack_public_path__ + "static/media/A1-17-Kal-Belzeruk-cod99.f03758d3.png";